import { useNavigate } from 'react-router-dom';

import HorizontalContainer from 'components/containers/HorizontalContainer';

import useVersionPreference from 'hooks/useVersionPreference';

import useTranslation from './hooks/useTranslation';

import { TEST_ID, V2_HOME_PATH } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const VersionAvailabilityBanner: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID
}) => {
    const { SUB, TITLE, TRY_IT_NOW } = useTranslation();
    const { setPreferenceV2 } = useVersionPreference();
    const navigate = useNavigate();

    const handleTryItNow = () => {
        setPreferenceV2();
        navigate(V2_HOME_PATH);
    };

    return (
        <aside className={`${styles.versionAvailabilityBanner} ${className}`} data-testid={testId}>
            <HorizontalContainer className={styles.iconTextGroup}>
                <div className={styles.iconBox}>
                    <svg
                        className={styles.icon}
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                        viewBox="0 0 24 24"
                    >
                        <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                    </svg>
                </div>

                <div className={styles.text}>
                    <p className={styles.title}>{`${TITLE} ✨`}</p>

                    <p className={styles.sub}>{SUB}</p>
                </div>
            </HorizontalContainer>

            <div className={styles.actions}>
                <button className={styles.tryItNow} onClick={handleTryItNow} type="button">
                    {TRY_IT_NOW}
                </button>
            </div>
        </aside>
    );
};

export default VersionAvailabilityBanner;
